import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'formatCompliance';

export class FormatCompliance extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
